<template>
  <transition name="fade" mode="out-in">
    <router-view class="base"> </router-view>
  </transition>
</template>

<script>
export default {
  components: {}
}
</script>

<style lang="stylus">
.base {
    background-color #fff
    flex-direction column
}
</style>
